import { useApp } from "../state/store";
import { useLangStore, useT } from "../i18n/store";
import { useInstallPrompt } from "../hooks/useInstallPrompt";
import { Modal } from "./Modal";
import { Icon } from "./Icon";
import { Segmented } from "./Segmented";
import type { Lang } from "../i18n/store";

export interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
}

export const SettingsModal = ({ open, onClose }: SettingsModalProps) => {
  const t = useT();
  const lang = useLangStore((s) => s.lang);
  const setLang = useLangStore((s) => s.setLang);
  const resetAll = useApp((s) => s.resetAll);
  const { canInstall, promptInstall } = useInstallPrompt();

  const onReset = () => {
    if (confirm(t("app.resetConfirm"))) {
      resetAll();
      onClose();
    }
  };

  const onInstall = async () => {
    const result = await promptInstall();
    if (result === "accepted") onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={t("settings.title")}>
      <section className="settings-row">
        <div className="settings-row-text">
          <div className="settings-row-title">{t("app.lang")}</div>
          <div className="settings-row-hint">{t("settings.lang.hint")}</div>
        </div>
        <Segmented<Lang>
          small
          value={lang}
          onChange={(l) => setLang(l)}
          options={[
            { value: "en", label: "English" },
            { value: "ru", label: "Русский" },
          ]}
        />
      </section>

      {canInstall && (
        <section className="settings-row">
          <div className="settings-row-text">
            <div className="settings-row-title">{t("settings.install.title")}</div>
            <div className="settings-row-hint">{t("settings.install.hint")}</div>
          </div>
          <button className="btn ghost install" onClick={onInstall}>
            <Icon name="tray-arrow-down" size={15} />
            {t("app.install")}
          </button>
        </section>
      )}

      <section className="settings-row">
        <div className="settings-row-text">
          <div className="settings-row-title">{t("settings.reset.title")}</div>
          <div className="settings-row-hint">{t("settings.reset.hint")}</div>
        </div>
        <button className="btn ghost danger" onClick={onReset}>
          <Icon name="reset" size={15} />
          {t("app.reset")}
        </button>
      </section>

      <section className="settings-row settings-tip">
        <div className="settings-row-text">
          <div className="settings-row-title">{t("tips.title")}</div>
          <div className="settings-row-hint">{t("tips.body")}</div>
        </div>
      </section>
    </Modal>
  );
};
